import Api from '@/base/api.typings';
import env from '@/env/env';

export function obterDiaMesAnoFormatado(data: string) {
    if (data) {
        let date = new Date(data);

        let dia = obterNumeroFormatado(date.getDate());
        let mes = obterMesNumero(date.getMonth());
        let ano = date.getFullYear();

        return `${ano}-${mes}-${dia}`;
    }
    return null
}

export function obterDiaMesAnoPadraoBR(data: string) {
    if (data) {
        let date = new Date(data);

        let dia = obterNumeroFormatado(date.getDate());
        let mes = obterMesNumero(date.getMonth());
        let ano = date.getFullYear();

        return `${dia}/${mes}/${ano}`;
    }
    return null
}

export function obterDataFormatada(data: string) {
    let date = new Date(data);

    let dia = obterNumeroFormatado(date.getDate());
    let mes = obterMes(date.getMonth());
    let ano = date.getFullYear();
    let hora = obterNumeroFormatado(date.getHours());
    let minuto = obterNumeroFormatado(date.getMinutes());

    return `${dia} de ${mes} de ${ano} às ${hora}h${minuto}`;
}

function obterMesNumero(mes: number) {
    let meses = ["01","02","03","04","05","06","07","08","09","10","11","12"];
    return meses[mes];
}

function obterMes(mes: number) {
    let meses = [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro"
    ];

    return meses[mes];
}

function obterNumeroFormatado(numero: number) {
    if (numero < 10) return `0${numero}`;

    return numero.toString();
}

export function isMobile() {
    return window.innerWidth <= 768;
}

export function obterArquivosValidos(files: File[], extensoesAceitas: string[]) {
    let resultado: File[] = [];

    for (let file of files) {
        let arquivoValido = validarArquivo(file, extensoesAceitas);

        if (arquivoValido)
            resultado.push(file);
    }

    return resultado;
}

function validarArquivo(file: File, extensoesAceitas: string[]) {
    let extensao = '.' + file.name.split('.').pop().toLowerCase();

    let extensaoExistente = extensoesAceitas.find(e => e == extensao);

    if (extensaoExistente)
        return true;

    return false;
}

export function debounce(func: Function, timeout?: number) {
    let timer: number | undefined;

    return (...args: any[]) => {
        const next = () => func(...args);

        if (timer) 
            clearTimeout(timer);

        timer = setTimeout(next, timeout > 0 ? timeout : 300);
    };
}

export function obterSituacaoDescricao(situacao: Api.Common.Domain.ChamadoSituacaoEnum) {
    switch (situacao) {
        case Api.Common.Domain.ChamadoSituacaoEnum.Aberto:
            return "Aberto";
        case Api.Common.Domain.ChamadoSituacaoEnum.Fechado:
            return "Fechado";
        case Api.Common.Domain.ChamadoSituacaoEnum.EmAndamento:
            return "Em andamento";
        default:
            break;
    }
}

export function obterSituacaoSistemaDescricao(situacao: Api.Common.Domain.SituacaoSistemaEnum) {
    switch (situacao) {
        case Api.Common.Domain.SituacaoSistemaEnum.Ativo:
            return "Ativo";
        case Api.Common.Domain.SituacaoSistemaEnum.EmAnalise:
            return "Em Análise";
        case Api.Common.Domain.SituacaoSistemaEnum.Inativo:
            return "Inativo";
        default:
            break;
    }
}

export function formatDateIso(date) {
    if (!date)
        return null;
    if (typeof date === 'number')
        date = new Date(date);
    if (date.toISOString)
        date = date.toISOString();
    const parts = date.split(/[-|\s|T]/)
    let day = parts[2].padStart(2, '0');
    let month = parts[1].padStart(2, '0');
    let year = parts[0].toString().padStart(2, '0');
    let result = `${year}-${month}-${day}`;
    return result;
}

export function configureIugu() {
    const iugu = (window as any).Iugu;
  
    iugu.setAccountID(env.iugu.accountId);
  
    if (env.iugu.testMode)
      iugu.setTestMode(true);
  
    iugu.setup();
}
